//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "NoResultsRow",
  props: {
    props: {
      type: null,
      default: null
    }
  }
});